import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Progress, Space, Table, Tag, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { formatDate, formatRupiah } from '@/lib/format';
import { useAuthStore } from '@/lib/auth-store';
export function ContractsPage() {
    const hasPerm = useAuthStore((s) => s.hasPerm);
    const q = useQuery({
        queryKey: ['abu-contracts'],
        queryFn: async () => (await api.get('/abu/contracts')).data,
    });
    const cols = [
        { title: 'No. Kontrak', dataIndex: 'contract_no', width: 200 },
        { title: 'Lokus', width: 130, render: (_, r) => `${r.room_code}·${r.niche_code}` },
        { title: 'Penyewa', dataIndex: 'tenant_name' },
        {
            title: 'Paket',
            dataIndex: 'plan',
            width: 120,
            render: (p) => _jsx(Tag, { color: "cyan", children: p }),
        },
        { title: 'Mulai', dataIndex: 'start_date', width: 110, render: (d) => formatDate(d) },
        { title: 'Berakhir', dataIndex: 'end_date', width: 110, render: (d) => formatDate(d) },
        {
            title: 'Nilai',
            dataIndex: 'total_amount',
            width: 160,
            align: 'right',
            render: (v) => _jsx("span", { className: "money", children: formatRupiah(v) }),
        },
        {
            title: 'Diakui',
            width: 200,
            render: (_, r) => {
                const total = parseFloat(r.total_amount) || 1;
                const rec = parseFloat(r.recognized_amount) || 0;
                const pct = Math.round((rec / total) * 100);
                return (_jsxs(Space, { direction: "vertical", size: 0, style: { width: '100%' }, children: [_jsx("span", { className: "money", children: formatRupiah(rec) }), _jsx(Progress, { percent: pct, size: "small" })] }));
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            width: 110,
            render: (s) => (_jsx(Tag, { color: s === 'ACTIVE' ? 'green' : s === 'EXPIRED' ? 'default' : 'red', children: s })),
        },
        {
            title: 'Jurnal',
            dataIndex: 'journal_id',
            width: 100,
            render: (id) => id ? _jsx(Link, { to: `/accounting/journals/${id}`, children: "Lihat" }) : '—',
        },
    ];
    return (_jsxs("div", { children: [_jsxs(Space, { style: { marginBottom: 16, display: 'flex', justifyContent: 'space-between' }, children: [_jsx(Typography.Title, { level: 3, style: { margin: 0 }, children: "Kontrak Rumah Abu" }), hasPerm('abu.contract:create') && (_jsx(Link, { to: "/abu/contracts/new", children: _jsx(Button, { type: "primary", icon: _jsx(PlusOutlined, {}), children: "Kontrak Baru" }) }))] }), _jsx(Table, { rowKey: "id", loading: q.isLoading, dataSource: q.data ?? [], columns: cols, pagination: { pageSize: 30 }, size: "middle" })] }));
}
